(function () {
  function initVedicaFaq(root) {
    if (!root || root.dataset.faqReady === 'true') {
      return;
    }

    root.dataset.faqReady = 'true';

    const items =
      Array.from(
        root.querySelectorAll('[data-va-faq-item]')
      );

    const filters =
      Array.from(
        root.querySelectorAll('[data-va-faq-filter]')
      );

    const searchInput =
      root.querySelector('[data-va-faq-search]');

    const resultCount =
      root.querySelector('[data-va-faq-count]');

    const emptyState =
      root.querySelector('[data-va-faq-empty]');

    const popularButtons =
      Array.from(
        root.querySelectorAll('[data-va-faq-jump]')
      );

    let activeCategory = 'all';
    let activeQuery = '';

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function openItem(item, shouldScroll) {
      if (!item) {
        return;
      }

      const button =
        item.querySelector('[data-va-faq-question]');

      const answer =
        item.querySelector('[data-va-faq-answer]');

      item.classList.add('is-open');

      if (button) {
        button.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      if (answer) {
        answer.setAttribute(
          'aria-hidden',
          'false'
        );
      }

      if (shouldScroll) {
        window.setTimeout(
          function () {
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          },
          80
        );
      }
    }

    function closeItem(item) {
      if (!item) {
        return;
      }

      const button =
        item.querySelector('[data-va-faq-question]');

      const answer =
        item.querySelector('[data-va-faq-answer]');

      item.classList.remove('is-open');

      if (button) {
        button.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      if (answer) {
        answer.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    }

    function toggleItem(item) {
      if (
        item.classList.contains('is-open')
      ) {
        closeItem(item);
      } else {
        openItem(item, false);
      }
    }

    items.forEach(function (item) {
      const button =
        item.querySelector('[data-va-faq-question]');

      if (!button) {
        return;
      }

      button.addEventListener(
        'click',
        function () {
          toggleItem(item);
        }
      );
    });

    function applyFilters() {
      let visibleCount = 0;

      items.forEach(function (item) {
        const category =
          item.dataset.category || '';

        const searchableText =
          normalize(item.textContent);

        const categoryMatches =
          activeCategory === 'all' ||
          category === activeCategory;

        const queryMatches =
          !activeQuery ||
          searchableText.includes(activeQuery);

        const visible =
          categoryMatches &&
          queryMatches;

        item.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        }
      });

      if (resultCount) {
        resultCount.textContent =
          visibleCount === 1
            ? 'Showing 1 answer'
            : 'Showing ' +
              visibleCount +
              ' answers';
      }

      if (emptyState) {
        emptyState.classList.toggle(
          'is-visible',
          visibleCount === 0
        );
      }
    }

    function setCategory(category) {
      activeCategory =
        category || 'all';

      filters.forEach(function (button) {
        const isActive =
          button.dataset.vaFaqFilter ===
          activeCategory;

        button.classList.toggle(
          'is-active',
          isActive
        );

        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });

      applyFilters();
    }

    filters.forEach(function (button) {
      button.addEventListener(
        'click',
        function () {
          setCategory(
            button.dataset.vaFaqFilter
          );
        }
      );
    });

    if (searchInput) {
      searchInput.addEventListener(
        'input',
        function () {
          activeQuery =
            normalize(searchInput.value);

          applyFilters();
        }
      );

      document.addEventListener(
        'keydown',
        function (event) {
          if (
            event.key === '/' &&
            document.activeElement !==
              searchInput
          ) {
            event.preventDefault();

            searchInput.focus();
          }

          if (
            event.key === 'Escape' &&
            document.activeElement ===
              searchInput
          ) {
            searchInput.value = '';

            activeQuery = '';

            applyFilters();

            searchInput.blur();
          }
        }
      );
    }

    popularButtons.forEach(
      function (button) {
        button.addEventListener(
          'click',
          function () {
            const targetId =
              button.dataset.vaFaqJump;

            const target =
              root.querySelector(
                '#' +
                CSS.escape(targetId)
              );

            if (!target) {
              return;
            }

            activeCategory = 'all';
            activeQuery = '';

            if (searchInput) {
              searchInput.value = '';
            }

            setCategory('all');

            openItem(target, true);
          }
        );
      }
    );

    if (window.location.hash) {
      const hash =
        window.location.hash.slice(1);

      const item =
        root.querySelector(
          '#' + CSS.escape(hash)
        );

      if (
        item &&
        item.matches('[data-va-faq-item]')
      ) {
        setCategory('all');

        openItem(item, true);
      }
    }

    setCategory('all');
  }

  function initAll(scope) {
    const context =
      scope || document;

    if (
      context.matches &&
      context.matches(
        '[data-va-faq-root]'
      )
    ) {
      initVedicaFaq(context);
    }

    context
      .querySelectorAll(
        '[data-va-faq-root]'
      )
      .forEach(initVedicaFaq);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );
})();